// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/******* Shared styles - Header styles *******/
.header-right {
	display: flex;
	gap: 10px;
}

.application-drop {
	display: inline-block;
	padding: 0 12px;
	height: 34px;
	line-height: 34px;
	border-radius: 17px;
	border: 1px solid var(--N2-Grey-696969, #696969);
	background: var(--White-6F, #fff);
	box-shadow: 0 6px 58px 0 rgba(196, 203, 214, 0.1);
	position: relative;
	overflow: hidden;
	width: 200px;
	height: 34px;
	flex-shrink: 0;
	display: flex;
}

.application-drop .ant-select:not(.ant-select-customize-input) .ant-select-selector {
	border: none !important;
	width: 180px;
}

.application-drop img {
	width: 20px;
	height: 20px;
	margin-top: 6px;
}

.application-drop .ant-select-selection-item {
	color: var(--Black-60, #000);
	font-family: 'Segoe UI', sans-serif;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 48px;
}

/******** Shared styles - Batch delete styles *******/

.batch-delete-header {
	display: flex;
	align-items: center;
	gap: 10px;
	border: 1px solid #e7e7e7;
	border-radius: 4px 4px 0px 0px;
	border-bottom: none;
	background-color: #fff;
	height: 40px;
	padding: 0px 12px;
	font-family: 'Segoe UI', sans-serif;
	font-size: 14px;
	font-weight: 400;
}

.batch-delete-header .desc {
	color: #696969;
}

.batch-delete-header .btn {
	color: black;
	display: flex;
	align-items: center;
	gap: 4px;
}

/******* text base page styles *******/

.table-clm-title-cell {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	line-height: 40px;
	width: 188px;
}

.app-tabs {
	background-color: #fff;
	display: flex;
	padding: 16px 8px 0px 8px;
	border-radius: 8px 8px 0px 0px;
	justify-content: space-between;
}

.app-tabs .app-btn {
	height: 34px;
	line-height: 34px;
}

.app-tabs :where(.css-dev-only-do-not-override-1odpy5d).ant-tabs-top > .ant-tabs-nav::before,
:where(.css-dev-only-do-not-override-1odpy5d).ant-tabs-bottom > .ant-tabs-nav::before,
:where(.css-dev-only-do-not-override-1odpy5d).ant-tabs-top > div > .ant-tabs-nav::before,
:where(.css-dev-only-do-not-override-1odpy5d).ant-tabs-bottom > div > .ant-tabs-nav::before {
	border-bottom: none;
}

.edit-document-form .ant-form-item-explain-error {
	text-align: left;
}

.edit-document-form .ant-form-item-explain {
	text-align: left;
	color: #cc3939 !important;
	font-size: 12px !important;
}

/******* image base page styles *******/
.image-base-container {
	padding-left: 16px;
	background-color: #f4f4f4;
}

.title-cell {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	line-height: 40px;
	width: 224px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/resource/index.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;CACC,aAAa;CACb,SAAS;AACV;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,YAAY;CACZ,iBAAiB;CACjB,mBAAmB;CACnB,gDAAgD;CAChD,iCAAiC;CACjC,iDAAiD;CACjD,kBAAkB;CAClB,gBAAgB;CAChB,YAAY;CACZ,YAAY;CACZ,cAAc;CACd,aAAa;AACd;;AAEA;CACC,uBAAuB;CACvB,YAAY;AACb;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,4BAA4B;CAC5B,mCAAmC;CACnC,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA,qDAAqD;;AAErD;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,yBAAyB;CACzB,8BAA8B;CAC9B,mBAAmB;CACnB,sBAAsB;CACtB,YAAY;CACZ,iBAAiB;CACjB,mCAAmC;CACnC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,QAAQ;AACT;;AAEA,sCAAsC;;AAEtC;CACC,mBAAmB;CACnB,gBAAgB;CAChB,uBAAuB;CACvB,iBAAiB;CACjB,YAAY;AACb;;AAEA;CACC,sBAAsB;CACtB,aAAa;CACb,yBAAyB;CACzB,8BAA8B;CAC9B,8BAA8B;AAC/B;;AAEA;CACC,YAAY;CACZ,iBAAiB;AAClB;;AAEA;;;;CAIC,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,yBAAyB;CACzB,0BAA0B;AAC3B;;AAEA,uCAAuC;AACvC;CACC,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;CAChB,uBAAuB;CACvB,iBAAiB;CACjB,YAAY;AACb","sourcesContent":["/******* Shared styles - Header styles *******/\n.header-right {\n\tdisplay: flex;\n\tgap: 10px;\n}\n\n.application-drop {\n\tdisplay: inline-block;\n\tpadding: 0 12px;\n\theight: 34px;\n\tline-height: 34px;\n\tborder-radius: 17px;\n\tborder: 1px solid var(--N2-Grey-696969, #696969);\n\tbackground: var(--White-6F, #fff);\n\tbox-shadow: 0 6px 58px 0 rgba(196, 203, 214, 0.1);\n\tposition: relative;\n\toverflow: hidden;\n\twidth: 200px;\n\theight: 34px;\n\tflex-shrink: 0;\n\tdisplay: flex;\n}\n\n.application-drop .ant-select:not(.ant-select-customize-input) .ant-select-selector {\n\tborder: none !important;\n\twidth: 180px;\n}\n\n.application-drop img {\n\twidth: 20px;\n\theight: 20px;\n\tmargin-top: 6px;\n}\n\n.application-drop .ant-select-selection-item {\n\tcolor: var(--Black-60, #000);\n\tfont-family: 'Segoe UI', sans-serif;\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 48px;\n}\n\n/******** Shared styles - Batch delete styles *******/\n\n.batch-delete-header {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 10px;\n\tborder: 1px solid #e7e7e7;\n\tborder-radius: 4px 4px 0px 0px;\n\tborder-bottom: none;\n\tbackground-color: #fff;\n\theight: 40px;\n\tpadding: 0px 12px;\n\tfont-family: 'Segoe UI', sans-serif;\n\tfont-size: 14px;\n\tfont-weight: 400;\n}\n\n.batch-delete-header .desc {\n\tcolor: #696969;\n}\n\n.batch-delete-header .btn {\n\tcolor: black;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 4px;\n}\n\n/******* text base page styles *******/\n\n.table-clm-title-cell {\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tline-height: 40px;\n\twidth: 188px;\n}\n\n.app-tabs {\n\tbackground-color: #fff;\n\tdisplay: flex;\n\tpadding: 16px 8px 0px 8px;\n\tborder-radius: 8px 8px 0px 0px;\n\tjustify-content: space-between;\n}\n\n.app-tabs .app-btn {\n\theight: 34px;\n\tline-height: 34px;\n}\n\n.app-tabs :where(.css-dev-only-do-not-override-1odpy5d).ant-tabs-top > .ant-tabs-nav::before,\n:where(.css-dev-only-do-not-override-1odpy5d).ant-tabs-bottom > .ant-tabs-nav::before,\n:where(.css-dev-only-do-not-override-1odpy5d).ant-tabs-top > div > .ant-tabs-nav::before,\n:where(.css-dev-only-do-not-override-1odpy5d).ant-tabs-bottom > div > .ant-tabs-nav::before {\n\tborder-bottom: none;\n}\n\n.edit-document-form .ant-form-item-explain-error {\n\ttext-align: left;\n}\n\n.edit-document-form .ant-form-item-explain {\n\ttext-align: left;\n\tcolor: #cc3939 !important;\n\tfont-size: 12px !important;\n}\n\n/******* image base page styles *******/\n.image-base-container {\n\tpadding-left: 16px;\n\tbackground-color: #f4f4f4;\n}\n\n.title-cell {\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tline-height: 40px;\n\twidth: 224px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
